import React from 'react';
import { motion } from 'framer-motion';
import { Palmtree, Info } from 'lucide-react';
import { FoodSwapSection } from './FoodSwapSection';

export function VacationMode() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="theme-card p-4 relative overflow-hidden mb-4"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
      <div className="relative space-y-3">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative">
              <Palmtree className="w-5 h-5 text-primary" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <div>
              <h2 className="text-base font-medium">Vacation Mode</h2>
              <p className="text-xs text-muted-foreground">60/40 balance for treats</p>
            </div>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Info className="w-3 h-3" />
            <span>Toggle in top bar</span>
          </div>
        </div>

        {/* Food Swap */}
        <FoodSwapSection />
      </div>
    </motion.div>
  );
}